
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke353aRequest, Sgke353aResponse, Sgke353aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke353aService {

  /**
   * コンストラクタ
   * @param {Sgke353aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke353aService
   */
  constructor(
    public service: Sgke353aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE353A_供給再開作業割当登録API呼び出し
   * @param {Sgke353aRequest} request 
   * @returns {Observable<Sgke353aResponse>}
   * @memberof UsedSgke353aService
   */
  public doSgke353a(request: Sgke353aRequest): Observable<Sgke353aResponse> {
    return this.service.sgke353aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE353A');
          return throwError(err.message);
        })
      );
  }

}
